import React, { useContext } from "react";
import { ShopContext } from "../context/ShopContext";
import { Div, SideDrawer, Text, Row, Col } from "atomize";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import { FaArrowCircleRight } from "react-icons/fa";

const Cart = () => {
  const {
    isCartOpen,
    closeCart,
    checkout,
    removeItem,
    decrementQuantity,
    incrementQuantity,
    numberOfItems,
  } = useContext(ShopContext);

  return (
    <SideDrawer isOpen={isCartOpen} onClose={closeCart}>
      <div className='cart-logo-wrapper'>
        <img src={logo} className='cart-logo' alt='' />
      </div>
      {numberOfItems !== 0 ? (
        <Div className='cart' d='flex' flexDir='column' m={{ b: "4rem" }}>
          {checkout.lineItems &&
            checkout.lineItems.map((item) => (
              <Row className='cart-item' key={item.id}>
                <Col>
                  <Div
                    className='cart-img'
                    bgImg={item.variant.image.src}
                    bgSize='cover'
                    bgPos='center center'
                    h='5rem'
                    w='4rem'
                  />
                  <small
                    className='cart-remove'
                    onClick={() => removeItem(item.id)}
                  >
                    remove
                  </small>
                </Col>
                <Col>
                  <Text>{item.title}</Text>
                  <Text>{item.variant.title}</Text>
                  <div className='Line-item__quantity-container'>
                    <button
                      className='quantity-button'
                      onClick={() => decrementQuantity(item)}
                    >
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      className='quantity-button'
                      onClick={() => incrementQuantity(item)}
                    >
                      +
                    </button>
                  </div>
                </Col>
                <Col>
                  <Text>${item.variant.price.amount}</Text>
                </Col>
              </Row>
            ))}
          <p>${checkout.totalPrice.amount}</p>

          <a className='btn btn-dark' href={checkout.webUrl} target='_blank'>
            Checkout
          </a>
          <button className='btn btn-light' onClick={closeCart}>
            Continue Shopping
          </button>
        </Div>
      ) : (
        <div className='empty-cart'>
          <h4>Your cart is empty</h4>
          <p>Please enjoy exploring our range of delicious coffees.</p>
          <Link onClick={closeCart} className='btn btn-dark' to='/store'>
            Start shopping <FaArrowCircleRight />{" "}
          </Link>
        </div>
      )}
    </SideDrawer>
  );
};

export default Cart;
